// extracted by mini-css-extract-plugin
export default {"statsItem":"sEPt0","content":"cF5G7","selectableStatsItem":"tENq0","selected":"uLPV3","units":"rbOJO","unit":"gLqNJ","cost":"TifyP"};